import { Injectable } from '@angular/core';
import * as localforage from 'localforage';
import { IFileItem, IFolderList } from "./aws-s3-upload/multipart.interface";

// https://github.com/localForage/localForage
// https://localforage.github.io/localForage/#data-api-iterate
@Injectable({
  providedIn: 'root'
})
export class LocalForageService {
  foldersDb: any;
  filesDb: any;

  constructor() {
  }

  init() {
    localforage.config({
      driver: localforage.WEBSQL, // Force WebSQL; same as using setDriver()
      name: 'MangoS3UploadLocalForageDatabase',
      version: 1.0,
      size: 999999999 * 9999999999999, // Size of database, in bytes. WebSQL-only for now.
      storeName: 'keyvaluepairs', // Should be alphanumeric, with underscores.
      description: ''
    });

    this.filesDb = localforage.createInstance({
      name: "files"
    });

    this.foldersDb = localforage.createInstance({
      name: "folders"
    });
  }

  addOneFolder(folderItem: IFolderList) {
    this.foldersDb.setItem(folderItem.token, folderItem);
  }

  addOneFile(fileItem: IFileItem) {
    this.filesDb.setItem(fileItem.token, fileItem);
  }
}
